var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',_vm._b({staticClass:"AppButton-root",style:(_vm.styles),on:{"click":function($event){return _vm.$emit('click',$event)}},scopedSlots:_vm._u([_vm._l((Object.keys(_vm.$slots)),function(name){return {key:name,fn:function(){return [_vm._t(name)]},proxy:true}})],null,true)},'el-button',_vm.buttonPropsResult,false))
}
var staticRenderFns = []

export { render, staticRenderFns }